import {AppTableFilters, CreateTextFilter} from "../../services/AppTableFilters";
import {t} from "../../utilities/TranslationUtils";

export const ClientsTableFilterInstance = new AppTableFilters();
export const ClientsTableColumns = (data: any) => {
  return [
    {
      id: 'id',
      Header: t('clients.identifier'),
      accessor: 'id',
      filter: CreateTextFilter(ClientsTableFilterInstance, 'id', t('clients.identifier'))
    },
    {
      id: 'name',
      Header: t('clients.name'),
      accessor: 'name',
      filter: CreateTextFilter(ClientsTableFilterInstance, 'name', t('clients.name'))
    },
    {
      id: 'actions',
      Header: t('clients.action')
    }
  ];
}